/**
 * Navigation helpers: keyboard support, mobile accordion, sticky detection.
 */

/**
 * Closes the mobile nav when the Escape key is pressed.
 */
export function initNavigation() {
	const burger = document.querySelector( '.site-header__burger' );
	const nav    = document.querySelector( '.site-nav' );

	if ( ! burger || ! nav ) return;

	document.addEventListener( 'keydown', ( e ) => {
		if ( e.key === 'Escape' && nav.classList.contains( 'is-open' ) ) {
			burger.click();
			burger.focus();
		}
	} );
}

/**
 * Injects a chevron toggle button next to each parent link in the nav and wires
 * up accordion open/close for mobile. The buttons are hidden via CSS on desktop.
 */
export function initMobileSubmenu() {
	const nav = document.querySelector( '.site-nav' );
	if ( ! nav ) return;

	nav.querySelectorAll( '.menu-item-has-children' ).forEach( ( item ) => {
		const link    = item.querySelector( ':scope > a' );
		const subMenu = item.querySelector( ':scope > .sub-menu' );
		if ( ! link || ! subMenu ) return;

		const btn = document.createElement( 'button' );
		btn.className = 'site-nav__toggle';
		btn.type      = 'button';
		btn.setAttribute( 'aria-expanded', 'false' );
		btn.setAttribute( 'aria-label', 'Afficher le sous-menu' );
		btn.innerHTML =
			'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="16" height="16" aria-hidden="true">' +
			'<path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>' +
			'</svg>';

		link.insertAdjacentElement( 'afterend', btn );

		btn.addEventListener( 'click', () => {
			const isOpen = item.classList.toggle( 'is-open' );
			btn.setAttribute( 'aria-expanded', String( isOpen ) );
		} );
	} );
}

/**
 * Adds `.is-scrolled` to `.site-header` when the page is scrolled past the top.
 */
export function initStickyHeader() {
	const header = document.querySelector( '.site-header' );
	if ( ! header ) return;

	function update() {
		header.classList.toggle( 'is-scrolled', window.scrollY > 0 );
	}

	window.addEventListener( 'scroll', update, { passive: true } );
	update();
}
